var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.page.label))]),_c('h3',[_vm._v("Edit Page")]),_c('PageForm',{attrs:{"edit-page":_vm.page,"parent-values":_vm.pagesParentValues},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }